import { z } from 'zod';

import type { AddScaleTicketRequest, AddScaleTicketResponse } from './add-scale-ticket.dto.js';
import {
  ShipmentScaleTicketInputSchema,
  ShipmentScaleTicketSchema,
} from './shipments-shared.schema.js';

const addScaleTicketBaseShape = {
  companyId: z.uuid(),
  shipmentId: z.uuid(),
  stationId: z.uuid(),
};

export const AddScaleTicketRequestSchema: z.ZodType<AddScaleTicketRequest> =
  ShipmentScaleTicketInputSchema.extend(addScaleTicketBaseShape).strict();

export const AddScaleTicketResponseSchema: z.ZodType<AddScaleTicketResponse> = z
  .object({
    scaleTicket: ShipmentScaleTicketSchema,
  })
  .strict();
